import axiosHandler from '../../Intersepter/axiosInstance';

//   Sends a withdrawal request with the specified data.
export const withdrawRequest = async (data) => {
  try {
    const response = await axiosHandler.post(`/wallet/withdraw_req`, data);
    return response.data; 
  } catch (error) {
    console.error("Error processing withdrawal request:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};


// Fetch withdraw requests API function
export const fetchWithdrawRequests = async (userId) => {
  try {
    const response = await axiosHandler.get(`/user/withdraw-req/${userId}`);
    return response;
  } catch (error) {
    console.error("Error fetching withdraw requests:", error);
    throw error;
  }
};
